import type { KgFlowNode } from "../../components/kg/canvas/types";
import {
  KG_CATALOG_SECTION_IDS,
  resolveCatalogSectionId,
} from "./kgCatalog.constants";
import type {
  GroupedCatalogNodes,
  KgCatalogSectionId,
} from "./kgCatalog.types";

const emptyGrouped = (): GroupedCatalogNodes =>
  Object.fromEntries(
    KG_CATALOG_SECTION_IDS.map((id) => [id, [] as KgFlowNode[]]),
  ) as GroupedCatalogNodes;

/** Groups graph nodes into catalog sections by flow node type. */
export const groupNodesByCatalogSection = (
  nodes: readonly KgFlowNode[],
): GroupedCatalogNodes => {
  const grouped = emptyGrouped();

  for (const node of nodes) {
    const sectionId = resolveCatalogSectionId(node.type);
    if (!sectionId) continue;
    grouped[sectionId].push(node);
  }

  return grouped;
};

/** Sections with at least one node after grouping. */
export const getNonEmptyCatalogSectionIds = (
  grouped: GroupedCatalogNodes,
): KgCatalogSectionId[] =>
  KG_CATALOG_SECTION_IDS.filter((id) => grouped[id].length > 0);

export const hasAnyCatalogNodes = (grouped: GroupedCatalogNodes): boolean =>
  getNonEmptyCatalogSectionIds(grouped).length > 0;

/** Caption shown when a catalog section is expanded but has no nodes. */
export const getKgCatalogSectionEmptyMessage = (
  sectionLabel: string,
  hasActiveFilters: boolean,
): string => {
  const label = sectionLabel.toLowerCase();
  return hasActiveFilters
    ? `No ${label} match the current filters.`
    : `No ${label} in this workspace yet.`;
};
